import { useState, useEffect, useRef } from 'react';
import { WidgetProps } from '@rjsf/utils';
import {
    useGetList,
    useGetOne
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material'
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PreviewIcon from '@mui/icons-material/Preview';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { ModelSchema } from "../../../../../types/entities";
import {
    TextField
} from '@mui/material';
/**
 * Custom React JSON Schema Form Widget for selecting a Prompt Template
 * @param props
 * @constructor
 */
export const ModelSchemaWidget = (props: WidgetProps) => {
    const { value, onChange, formContext, registry, disabled } = props;
    const [templates, setTemplates] = useState<ModelSchema[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<ModelSchema>(null);
    const [showList, setShowList] = useState<boolean>(false);
    const [templatePreview, setTemplatePreview] = useState<string>(null);
    const { data, total, isPending, error } = useGetList('model_schemas', {  })
    // TODO - Add Pagination to the dropdown

    function handleShowList() {
        if (!disabled) {
            setShowList(!showList);
        }
    }

    function handleTemplateSelect(template: any) {
        if (!disabled) {
            setShowList(false);
            setSelectedTemplate(template);
        }
    }

    function handleTemplatePreview() {
        if (!disabled) {
            setTemplatePreview(selectedTemplate.modelSchema);
        }
    }

    function handleConfirmTemplate() {
        if (!disabled) {
            onChange(templatePreview);
            setTemplatePreview(null);
            setSelectedTemplate(null);
            setShowList(false);
        }
    }

    function handleCancelTemplate() {
        if (!disabled) {
            setTemplatePreview(null);
            setSelectedTemplate(null);
            setShowList(false);
        }
    }

    useEffect( () => {
        if (data) {
            setTemplates(data);
        }
    }, [data] );

    if (isPending) {
        return <div><span>Loading Schemas...</span><LinearProgress /></div>;
    }

    return (
        <div className="dialog__prompt-template-list custom-form-widget">
            <div className="prompt-template-list__list">
                <div className="list__list">
                    <div className={ "list__selected " + (disabled ? 'disabled' : '') } onClick={ handleShowList }>
                        <span>{ selectedTemplate !== null ? selectedTemplate.name : 'Select Template and preview...' }</span>
                        { showList ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
                    </div>
                    { (!disabled) &&
                        <div className={ "list__items " + (showList ? "show" : "") }>
                            { templates.map( (template: ModelSchema, index: number) => {

                                return (
                                    <span key={ "system_schema_option_" + index }
                                          className={ "list__item " + (selectedTemplate !== null && selectedTemplate.id === template.id ? "selected" : "") }
                                          onClick={ () => handleTemplateSelect(template) }
                                    > { template.name } </span>
                                );
                            } ) }
                        </div>
                    }

                </div>

                <div className="list__actions">
                    <span className="action preview"
                          title="Preview Template"
                          onClick={ handleTemplatePreview }
                    >
                        <PreviewIcon />
                    </span>
                    <span className="action confirm"
                          title="Confirm Template"
                          onClick={ handleConfirmTemplate }
                    >
                        <CheckIcon />
                    </span>
                    <span className="action cancel"
                          title="Cancel"
                          onClick={ handleCancelTemplate }
                    >
                        <CloseIcon />
                    </span>
                </div>
            </div>
            <div className="prompt-template-prompt">
                { (templatePreview !== null) &&
                    <pre className="preview__preview">
                        { templatePreview }
                    </pre>
                }
                { (templatePreview === null) &&
                    <TextField
                        multiline
                        disabled={ disabled }
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        rows={5}
                        style={{ width: "100%" }}
                    />
                }

            </div>

        </div>
    );
}